import { Component, OnInit, Input } from '@angular/core';
import { HelpersService } from 'src/app/services/helpers.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.page.html',
  styleUrls: ['./modal.page.scss'],
})
export class ModalPage implements OnInit {

  @Input() data: any = {};
  @Input() content: any = '';
  @Input() title: string;
  @Input() icon: string = 'close-outline'; 
  @Input() logo: string; 
  @Input() cls: string; 
  @Input() titleTranslate: string = 'false';


  modalContent: any;

  private modalController: any;

  constructor(
    private helpersService: HelpersService
  ) { 
    this.modalController = this.helpersService.modalController;
  }

  async ngOnInit() {
      // this.content = await this.content;

      /// Melhorar isso aqui, passar a var num div no modal como [innerHTML]
      document.querySelector('#jsmx-modalPageContent').innerHTML = this.content;
  }

  async ionViewWillEnter() {}
  
  async close(){ 
    await this.modalController.dismiss({
      'dismissed': true,

    });
  }
}
